export default {
    parameters: {
        landing_id: "LTGL",
    },
    downtimeUrl: "https://cl.kodland.tech",
    
    startPage: {
      image: "/welcome/quiz_peru.png",
      imageMobile: "/welcome/quiz_peru_mobile.png",
      title: "Responde a 4 preguntas y recibe una clase gratuita para tu hijo/a de 8 a 17 años",
      subtitle: "Tu hijo/a podrá participar en la clase que prefiera",
      button: "Comenzar 🚀",
    },
    successPage: {
      title: "¡Felicitaciones! 🎁",
      subtitle: "Haz clic en '📆 Reservar una clase' para completar el registro",
      button: "📆 Reservar una clase",
    },
    quizRotateBySteps: {
      1: {
        stopNew: true,
        question:
          "Vamos a conocernos, nosotros somos Kodland, ¿y usted?",
          answers: [
            {
              answer: "Soy padre",
              event_name: "parent",
              event_source: "google"
            },
            {
              answer: "Soy un niño/a entre 13 y 17 años",
              event_name: "child",
              event_source: "google",
              stopAnswer: true
            },
        ],
        stopPage: {
          image: "/welcome/quiz_stop_page.jpg",
          title: 'Lamentablemente, la participación de los padres es obligatoria para unirse a nuestra clase. Para reservar una clase gratuita <p> <a href="https://www.kodland.org/welcome/quiz/latam_for_google_ads2?utm_source={{site_source_name}}&utm_medium={{placement}}&utm_campaign={{adset.name}}&utm_content={{ad.id}}&utm_term={{ad.name}}">enlace más abajo<a> <p>¡envíalo a tus padres y te estaremos esperando en nuestras aulas! ',
        },
      },
      2: {
        question:
          "¿Te gustaría que el tiempo que tu hijo/a pasa en la computadora fuera más productivo?",
        answers: ["🔥 ¡Si!", "🤗 No. Lo hace solo para divertirse y eso está bien"],
      },
      3: {
        question: "¿Cuáles son las habilidades de tu hijo/a con la computadora/portátil?",
        answers: [
          "👍 No tiene conocimientos, debe estudiar lo básico",
          "🙌 Nivel básico, sabe usar Power Point y otras aplicaciones",
          "🖥 Nivel intermedio, quiere profundizar conocimientos",
          "🕹 Usa los dispositivos más que nada para juegos",
        ],
      },
      4: {
        question:
          "En estos momentos, ¿Que es lo más importante para ti en el desarrollo de tu hijo/a?",
        answers: [
          "🤔 Habilidades blandas",
          "🎓 Preparación para una carrera a futuro",
          "🖥 Actividades extracurriculares",
        ],
      },
      5: {
        stopNew: true,
        question: "¿Tienes una computadora de escritorio/portátil donde puedas trabajar?",
        answers: [
          "💻 Sí",
          {
            answer: "😐 No",
            stopAnswer: true
          },
        ],
        stopPage: {
          image: "/welcome/quiz_stop_page.jpg",
          title: "¡Gracias por confiar en nuestra plataforma educativa! Desafortunadamente, las tabletas o los teléfonos no son adecuados para tomar nuestras lecciones. ¡Estaremos felices de verlos en nuestras aulas la próxima vez!",
        },
      },
    },
  };
